import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';
import { getOptions } from 'domain/fuse/models/model';
import { getCouriers } from 'domain/tap/apis';
import { filterVehicleTypes } from 'domain/vehicle/utils';
import { getFleetByName } from 'domain/fleets/apis';
import { TEMP_CLASSIFICATIONS } from 'domain/operations/drivers/constants';
import { STRATEGY_TYPES } from 'domain/tap/constants';

export const NAME = `${APP_NAME}/PRODUCT_TYPE`;

export const OWNERSHIP_TYPES = [
  { value: 'OWNER', label: I18n.str('owner', 'Owner') },
  { value: 'LEASER', label: I18n.str('leaser', 'Leaser') },
];
export const REDUCER_NAME = 'vehicles';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/masheed/constant/sales-categories`;

export const ROUTES = {
  ROOT: '/products',
};

export const PAGE_NAME = 'productTypes';
